import "./styles.scss";

import { useTranslation } from "react-i18next";

import Button from "components/Button";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "dashboard-client-need-help";

const NeedHelp = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__text`}>
        <span className="light">{t("Need help?")}</span>
        <p className="light">
          {t("Use our extensive FAQ or get in touch with our specialists.")}
        </p>
      </div>
      <div className={`${mainClass}__buttons`}>
        <Button href="/faq" fullWidth>
          {t("See FAQ")}
        </Button>
        <Button href="/contact" fullWidth variant="transparent-white">
          {t(max.sm ? "Contact" : "contact us")}
        </Button>
      </div>
    </div>
  );
};

export default NeedHelp;
